import _ from 'lodash';
import { t } from '@lingui/macro';

const viewLabel = t`View details for`;

export const percentConfig = {
    units: '%',
    multiplier: 1,
    forceDecimals: true,
};

export function listTooltip(...selectors) {
    return function tooltip(row) {
        return selectors.reduce((prev, curr, idx) => {
            const item = _.get(row, curr);
            return item ? `${prev} ${idx !== 0 ? `(${item})` : item}` : prev;
        }, viewLabel);
    };
}

export function percentSparkLinkFn(key, label) {
    const chartTrends = [
        {
            color: 'rgb(93, 165, 218)',
            key,
            label,
            max: 100,
            ...percentConfig,
        },
    ];

    return (rowData) => ({
        chartDef: {
            chartTrends,
        },
        data: rowData,
    });
}
